<template>
  <div>
    <h1 class="">Página inicial {{menusAppUsuario.titulo}}!</h1>
  
    <div class="dashboard-shortcuts">
      <template v-for="(menu, index) in menusAppUsuario.submenu">
        <a
          v-if="menu.link_externo"
          :key="'ext-' + index"
          :href="menu.url"
          target="_blank"
        >
          {{ menu.titulo }}
        </a>
        <router-link
          v-else
          :key="'int-' + index"
          :to="menu.url"
        >
          {{ menu.titulo }}
        </router-link>
      </template>
    </div>

     <div v-for="item in items" v-bind:key="item.id">
        
      </div>

  </div>
  
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "SGPHomePageComponent",

  data () {
    return {
      menusAppUsuario: []
    }
  },

  computed: {
      ...mapGetters('login', ['usuarioLogado']),
      buscarMenusAppUsuario(){
        return this.usuarioLogado.menus.filter(menu => menu.url === this.$route.path)[0];
      }
  },

  created () {
    this.menusAppUsuario = this.buscarMenusAppUsuario;
  }
};


</script>

<style lang="scss" scoped>
.dashboard-shortcuts {
  display: flex;
  align-content: space-around;
  justify-content: left;
  flex-wrap: wrap;
  flex-direction: row;
  // background: red;

  a {
    display: flex;
    align-items: flex-end;
    margin: 5px;
    justify-content: left;
    border: solid 1px #ccc;
    width: 180px;
    height: 160px;
    padding: 25px 25px 0 25px;
    border-radius: 10px;
    text-decoration: none;
    transition: all 0.5s;

    &:hover {
      border-color: red;
    }
  }
}
</style>